import { border, styled, truncate } from '@elliemae/ds-system';
import { useEffect, useRef, useState } from 'react';

const RegionWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Region = styled.div<{ hide: boolean; animate: boolean; refHeight: number }>`
  display: flex;
  ${(props) => (props.hide ? 'visibility: hidden;' : '')}
  transition: max-height ${(props) => (props.animate ? '0.25s' : '0.20s')} linear;
  max-height: 0;
  ${(props) =>
    props.animate
      ? `
      max-height: ${props.refHeight}px;
    `
      : ''}
  align-items: center;
  ${truncate()};
  border-top: ${(props) => border(props.theme.colors.neutral['300'])};
  font-weight: ${(props) => props.theme.fontWeights.regular};
`;

export const ExpandableRegion = ({ show, content }: { show: boolean; content: JSX.Element | JSX.Element[] }) => {
  const ref = useRef<HTMLDivElement>(null);
  // triggers transition
  const [animate, setAnimate] = useState(show);
  // needed to properly handle the transition. Hide after transition ends
  const [hide, setHide] = useState(!show);
  useEffect(() => {
    setAnimate(show);
    if (show) setHide(false);
  }, [show]);

  const hideOnAnimationEnd = () => {
    if (!show) setHide(true);
  };

  return (
    <Region
      hide={hide}
      // needed to handle transition, `auto` max-height isn't supported
      refHeight={ref?.current?.scrollHeight || 9999}
      onTransitionEnd={hideOnAnimationEnd}
      animate={animate}
    >
      <RegionWrapper innerRef={ref}>{content}</RegionWrapper>
    </Region>
  );
};
